import { IsNotEmpty, IsString, IsOptional, IsArray } from 'class-validator';
import { IBaseResponse } from './base-response.dto';
import { IEmailTemplate } from './email-template';
import { ISegment } from './segment';

export type CampaignType = 'email-campaign';
export type CampaignStatus = 'new' | 'launched';

export class ICampaign {
  _id?: string;
  label: string;
  type: CampaignType;
  status: CampaignStatus;
  description: string;
  organization: string;
  emailTemplate: string | IEmailTemplate;
  subject: string;
  previewText: string;
  senderName: string;
  senderEmail: string;
  replyToEmail?: string;
  segmentsToInclude: Array<string | ISegment>;
  segmentsToExclude: Array<string | ISegment>;
  createdAt?: string;
  updatedAt?: string;
}

/* -------------------------------------------------------------------------- */
/*                               Create new Campaign                              */
/* -------------------------------------------------------------------------- */

export class CreateCampaignDto {
  @IsNotEmpty()
  @IsString()
  label: string;
  @IsNotEmpty()
  @IsString()
  type: CampaignType;
  @IsNotEmpty()
  @IsString()
  subject: CampaignType;
  @IsNotEmpty()
  @IsString()
  previewText: CampaignType;
  @IsNotEmpty()
  @IsString()
  senderName: CampaignType;
  @IsNotEmpty()
  @IsString()
  senderEmail: CampaignType;
  @IsString()
  @IsOptional()
  replyToEmail?: string;
  @IsNotEmpty()
  @IsString()
  emailTemplate: string;
  @IsString()
  @IsOptional()
  description?: string;
  @IsString()
  @IsOptional()
  organization?: string;
  @IsArray()
  segmentsToInclude?: string[];
  @IsArray()
  segmentsToExclude?: string[];
}

export interface CreateCampaignResponse extends IBaseResponse {
  campaign: ICampaign;
}

/* -------------------------------------------------------------------------- */
/*                                   Update Campaign                              */
/* -------------------------------------------------------------------------- */

export class UpdateCampaignDto {
  @IsNotEmpty()
  @IsString()
  label: string;
  @IsNotEmpty()
  @IsString()
  subject: CampaignType;
  @IsNotEmpty()
  @IsString()
  previewText: CampaignType;
  @IsNotEmpty()
  @IsString()
  senderName: CampaignType;
  @IsNotEmpty()
  @IsString()
  senderEmail: CampaignType;
  @IsString()
  @IsOptional()
  replyToEmail?: string;
  @IsNotEmpty()
  @IsString()
  emailTemplate: string;
  @IsString()
  @IsOptional()
  description?: string;
  @IsString()
  @IsOptional()
  organization?: string;
  @IsArray()
  segmentsToInclude?: string[];
  @IsArray()
  segmentsToExclude?: string[];
}

export interface UpdateCampaignResponse extends IBaseResponse {
  id: string;
}

/* -------------------------------------------------------------------------- */
/*                                  Get Campaigns                                 */
/* -------------------------------------------------------------------------- */
export class GetCampaignsDto {
  type?: CampaignType;
  label?: string
}

export type GetCampaignsResponse = ICampaign[];
